import React, { FC } from 'react';

import { InnerLayout } from 'pages';

const MyTransactionsLayout: FC = () => <InnerLayout />;

export default MyTransactionsLayout;
